import { render, staticRenderFns } from "./LeasesDetailsForm.vue?vue&type=template&id=3070212e&scoped=true"
import script from "./LeasesDetailsForm.vue?vue&type=script&lang=js"
export * from "./LeasesDetailsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3070212e",
  null
  
)

export default component.exports